import compose from 'compose-function';
import {
  withToast,
  withLoaderRoot,
} from '@shared/ui';
import {
  withJoyTheme,
  withMuiTheme
} from '@entities/theme';
import {
  withCheckLoggedIn
} from '@features/check-logged-in';
import {
  withOutdatedAppVersionModal
} from '@features/check-app-version';
import {
  withGoogleTagManager8847,
  withGoogleTagManager1903,
  withGoogleTagManager2592,
  withGoogleTagManager5292,
} from '@features/collect-analytics';
import {
  appRouter
} from '../app-router';
import {
  withStore
} from './with-store.component';
import {
  withErrorBoundary
} from './with-error-boundary.component';
import {
  withFullScreenListener
} from './with-full-screen-listener.component';

export const withProviders = compose(
  withJoyTheme,
  withMuiTheme,
  withStore,
  withGoogleTagManager8847,
  withGoogleTagManager1903,
  withGoogleTagManager2592,
  withGoogleTagManager5292,
  withCheckLoggedIn({ navigate: appRouter.navigate }),
  withOutdatedAppVersionModal,
  withErrorBoundary,
  withLoaderRoot,
  withToast,
  withFullScreenListener,
);
